<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="addOrMaterialImgTextDialog"
    :click-not-close="true"
  >
    <img-text-content
      ref="outform"
      @add-success="addSuccess"
      @edit-success="editSuccess"
    ></img-text-content>
  </sliderBarDialogShell>
</template>

<script>
import imgTextContent from '../../../../components/wx/material/materialNew/imgTextContent'

export default {
  name: "addOrEditImgTextDialog",
  components: {
    imgTextContent,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {

    }
  },
  computed: {
    name(){
      return this.isEdit == true ? '编辑': '新增';
    },
    title() {
      return `${name}图文素材`;
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    editSuccess(){
      this.$emit('edit-success');
    },
    addSuccess(){
      this.$emit('add-success');
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .addOrMaterialImgTextDialog.sidebar-dialog .vs-sidebar {
    width: 1000px;
  }
}
</style>
